import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, amount: 0.15 }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <p className="flex items-center gap-3 font-mono text-[11px] font-semibold uppercase tracking-[0.24em] text-oak">
        <span className="inline-block h-px w-10 bg-oak" />
        {children}
    </p>
);
